import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MyHttpClientFactory, environment } from '@ups/xplat/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EmployeePacketService {
  httpClient: HttpClient;
  route = '/api/packetforms';
  constructor(httpFactory: MyHttpClientFactory) {
    this.httpClient = httpFactory.createHttpClient(
      environment.urls.packetAPI,
      true
    );
  }

  /** SSN goes in the POST body, never the URL (WI 34368). */
  getPacketDocuments(ssn: string) {
    return this.httpClient
      .post(`${this.route}/listbyssn`, { ssn })
      .pipe(catchError(this.handleError));
  }

  /** Bug 37205: a 403 is the API's answer for no packet or out of scope, not a failure, so it is not logged. */
  getPacketDocumentsByHrref(hrref: string) {
    return this.httpClient
      .get(`${this.route}/listbyhrref/${hrref}`)
      .pipe(
        catchError((error) =>
          error?.status === 403
            ? throwError(() => error)
            : this.handleError(error)
        )
      );
  }

  getAllUniquePacketDocumentsFilenames() {
    return this.httpClient
      .get(`${this.route}/listallunique`)
      .pipe(catchError(this.handleError));
  }

  downloadPdfForm(formId: number) {
    return this.httpClient
      .get(`${this.route}/${formId}/download`, { responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }

  /** AcroForm field map for DocuSign / previews (Employee Packet API). */
  getFormFieldData(formId: number) {
    return this.httpClient
      .get<Record<string, string>>(`${this.route}/${formId}/formfielddata`)
      .pipe(catchError(this.handleError));
  }

  // Error types could be anything
  // https://angular.io/api/core/ErrorHandler
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error?.error?.Message || error);
  }
}
